import { render } from "./EditEmailTemplate.vue?vue&type=template&id=0f3620e2"
import script from "./EditEmailTemplate.vue?vue&type=script&lang=js"
export * from "./EditEmailTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__